<template>
    <div class="grid max-w-xl grid-cols-1 gap-x-4 gap-y-4 py-2">
        <BaseInputCheckbox
            v-model="formValues.tax_authorities"
            :label="$t('legal_acknowledgements.tax_authorities')"
            :required="isRequiredLegalComplianceProfileAttribute('acknowledgements', 'tax_authorities')"
            name="acknowledgements.tax_authorities"></BaseInputCheckbox>
        <BaseInputCheckbox
            v-model="formValues.intergovernmental_tax_exchange"
            :required="isRequiredLegalComplianceProfileAttribute('acknowledgements', 'intergovernmental_tax_exchange')"
            :label="$t('legal_acknowledgements.intergovernmental_tax_exchange')"
            name="acknowledgements.intergovernmental_tax_exchange"></BaseInputCheckbox>
        <BaseInputCheckbox
            v-model="formValues.notify_about_changes"
            :required="isRequiredLegalComplianceProfileAttribute('acknowledgements', 'notify_about_changes')"
            :label="$t('legal_acknowledgements.notify_about_changes')"
            name="acknowledgements.notify_about_changes"></BaseInputCheckbox>
        <BaseInputCheckbox
            v-model="formValues.information_correct_and_complete"
            :required="
                isRequiredLegalComplianceProfileAttribute('acknowledgements', 'information_correct_and_complete')
            "
            :label="$t('legal_acknowledgements.information_correct_and_complete')"
            name="acknowledgements.information_correct_and_complete"></BaseInputCheckbox>
    </div>
</template>

<script setup lang="ts">
import BaseInputCheckbox from '../../../../../base/BaseInputCheckbox.vue'
import { isRequiredLegalComplianceProfileAttribute, LegalAcknowledgmentsTwo } from '../forms'
import { useVModel } from '@vueuse/core'

const props = defineProps<{
    modelValue: LegalAcknowledgmentsTwo
}>()
const emit = defineEmits(['update:modelValue'])

const formValues = useVModel(props, 'modelValue', emit)
</script>
